const regex = /(?:\.([^.]+))?$/;

export const getVideoFormatFromUrl = (url: string) => {
  const result = regex.exec(url);
  return result && result[1];
};
